export default __webpack_public_path__ + "static/media/HomeLogo2.974b2020.png";